import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MainComponent } from './main.component';
import { DashboardModule } from '@app/dashboard/dashboard.module';
import { ContactTabsModule } from '@app/contact-tabs/contact-tabs.module';
import { EnergieMonitorModule } from '@app/energiemonitor/energiemonitor.module';
import { StorungenModule } from '@app/storungen/storungen.module';
import { ProductCatalogManagementModule } from '@app/product-catalog-management/product-catalog-management.module';
import { EnergyMapModule } from '@app/energy-map/energy-map.module';
import { ManagementTabsModule } from '@app/management-tabs/management-tabs.module';
import { ContactPageModule } from '@app/contact-page/contact-page.module';
import { ServiceAppsModule } from '@app/service-apps/service-apps.module';

@NgModule({
  declarations: [MainComponent],
  imports: [
    CommonModule,
    SharedModule,
    ContactTabsModule,
    DashboardModule,
    StorungenModule,
    EnergieMonitorModule,
    ProductCatalogManagementModule,
    ManagementTabsModule,
    EnergyMapModule,
    ContactPageModule,
    ServiceAppsModule,
  ],
})
export class MainModule {}
